
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/BlogMessagePage/BlogMessagePage",
      function () {
        return require("private-next-pages/blogs/BlogMessagePage/BlogMessagePage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/BlogMessagePage/BlogMessagePage"])
      });
    }
  